<template>
  <v-navigation-drawer v-model="showAppChatMenu" class="pl-chat__menu" absolute temporary>
    <div class="pl-chat__menu-item pl-chat__menu-item--close">
      <v-btn icon @click="closeAppChatMenu()">
        <v-icon color="rgba(0,0,0,0.6)">arrow_back</v-icon>
      </v-btn>
    </div>

    <v-divider />
    <!--  <v-list-->
    <!--    dense-->
    <!--    rounded-->
    <!--  >-->
    <!--    <v-list-item-->
    <!--      link-->
    <!--    >-->
    <!--      <v-list-item-icon>-->
    <!--        <v-icon>add</v-icon>-->
    <!--      </v-list-item-icon>-->

    <!--      <v-list-item-content>-->
    <!--        <v-list-item-title>Создать групповой чат</v-list-item-title>-->
    <!--      </v-list-item-content>-->
    <!--    </v-list-item>-->
    <!--    <v-list-item-->
    <!--      link-->
    <!--    >-->
    <!--      <v-list-item-icon>-->
    <!--        <v-icon>setting</v-icon>-->
    <!--      </v-list-item-icon>-->

    <!--      <v-list-item-content>-->
    <!--        <v-list-item-title>Настройки текущего чата</v-list-item-title>-->
    <!--      </v-list-item-content>-->
    <!--    </v-list-item>-->
    <!--  </v-list>-->

    <div class="pl-chat__menu-item">
      <v-btn block depressed @click="createChat()">
        <!--                <v-icon color="rgba(0,0,0,0.6)">add</v-icon>-->
        Создать групповой чат
      </v-btn>
    </div>

    <div class="pl-chat__menu-item">
      <v-btn block depressed :disabled="disableButtonSettingChat" @click="openSettingChat()">
        <!--                <v-icon color="rgba(0,0,0,0.6)">add</v-icon>-->
        Настройки текущего чата
      </v-btn>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'PlChatMenu',
  data: () => {
    return {
      menuOpen: false,
    }
  },
  props: {
    showAppChatMenu: {
      type: Boolean,
      default: false,
    },
    disableButtonSettingChat: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showAppChatMenu(val) {
      this.menuOpen = val
    },
  },
  methods: {
    closeAppChatMenu() {
      this.$emit('close-app-chat-menu', this.menuOpen)
    },
    createChat() {
      this.$emit('create-chat')
    },
    openSettingChat() {
      this.$emit('open-setting-chat')
    },
  },
}
</script>

<style scoped lang="scss">
.pl-chat {
  &__menu {
    display: flex;
    flex-direction: column;
    padding: 1rem 1.6rem;
  }

  &__menu-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__menu-item--close {
    justify-content: flex-end;
  }

  &__menu-item-name {
    padding: 0 0.5rem;
    flex: 1 0 auto;
    text-transform: uppercase;
  }
}
</style>
